export default __webpack_public_path__ + "static/media/facebook_avatar.a597e952.svg";